import { createSlice } from '@reduxjs/toolkit';

export const initialFiltersState = {
  region: { label: 'Klimaregionen', value: 'climaregion' },
  mapSelection: { label: '', value: '-1' },
  climatic: { label: 'Temperatur', value: 'tas' },
  characteristic: { label: 'Mittlere Jahrestemperatur', value: 'tas-TM-Y' },
  rcpMap: { label: 'RCP 8.5', value: 'rcp85' },
  rcpMapComparison: { label: 'RCP 8.5 vs. RCP 2.6', value: 'rcp85VSrcp26' },
  rcpMulti: [{ label: 'RCP 8.5', value: 'rcp85' }],
  valueRange: { label: 'Median', value: 'median' },
  futureTimeRange: [2070, 2100],
  futureTimeRangeMedian: 2085,
  pastTimeRange: 2003,
};

const filtersSlice = createSlice({
  name: 'filters',
  initialState: initialFiltersState,
  reducers: {
    changeRegion(state, action) {
      state.region = action.payload;
      state.mapSelection = { label: '', value: 0 };
    },
    changeMapSelection(state, action) {
      state.mapSelection = action.payload;
    },
    changeClimaticSelection(state, action) {
      state.climatic = action.payload;
    },
    changeCharacteristicSelection(state, action) {
      console.log(action.payload);
      state.characteristic = action.payload;
    },
    changeRcpMapSelection(state, action) {
      state.rcpMap = action.payload;
    },
    changeRcpMapSelectionComparison(state, action) {
      state.rcpMapComparison = action.payload;
    },
    toggleRcpMulti(state, action) {
      const elementIndex = state.rcpMulti.findIndex(
        (element) => element.value === action.payload.value
      );

      if (elementIndex === -1) {
        state.rcpMulti.push(action.payload);
      } else if (state.rcpMulti.length > 1) {
        state.rcpMulti.splice(elementIndex, 1);
      }
    },
    changeValueRangeSelection(state, action) {
      state.valueRange = action.payload;
    },
    changeFutureTimeRange(state, action) {
      state.futureTimeRange = action.payload;
      state.futureTimeRangeMedian =
        action.payload[0] + (action.payload[1] - action.payload[0]) / 2;
    },
    changePastTimeRange(state, action) {
      state.pastTimeRange = action.payload;
    },
    changeMode(state, action) {
      state.mode = action.payload;
    },
  },
});

export const filtersActions = filtersSlice.actions;

export default filtersSlice.reducer;
